<script>
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/planning';

import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../../components/generic/GenericDataTable.vue';
import ImportWeeklyFromFile from '../../../components/planning/ImportWeeklyFromFile.vue';
import GenericBooleanDropdown from '../../../components/generic/GenericBooleanDropdown.vue';

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
        ResponsiveButton,
        GenericDataTable,
        ImportWeeklyFromFile,
        GenericBooleanDropdown
  },
  data(){
    return {
      filters: {
          initialInventoryDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
          endingInventoryDate: Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 0)),
      },
      configuration: {},
      submitted: false,
      addProvisionalInvoice: {},
      showProvisionalInvoiceDialog: false,
      showImportDialog: false,
      dateFromForImport: null,
      showImportFromExcelDialog: false
    }
  },
  validations(){
    return {
      filters: {
        initialInventoryDate: {required},
        endingInventoryDate: {}
      }
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configuration = config.getConfiguration('ProvisionalInvoice');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'provisionalInvoice.page_title');
  },
  methods: {
    load() {
        console.log(this.configuration);
        this.submitted = true;

        let filters = [];
        
        filters.push({
            operator: '>=',
            value: this.filters.initialInventoryDate,
            property: 'InitialInventoryDate',
        });

        filters.push({
            operator: '<=',
            value: this.filters.endingInventoryDate,
            property: 'EndingInventoryDate',
        })

        this.$refs.provisionalInvoice.filterFromView(filters);
        this.submitted = false;      
    },
    onProvisionalInvoiceEdit(data){
        this.$store.dispatch("generic/setLoading", true);
            Service.updateProvisionalInvoice(data, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.load();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
    },
    openAddDialog(){
      this.showProvisionalInvoiceDialog = true;
    },
    saveProvisionalInvoice(){
      Service.addProvisionalInvoice(this.addProvisionalInvoice, 
        response => {
          if(response.success){
            this.load();
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
          }else{
            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
    },
    importProvInvoice(){
      this.$confirm.require({
        message: this.$t('messages.confirm_import'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {                  
          let body = {
            dateFrom: this.dateFromForImport
          }

          this.$store.dispatch("generic/setLoading", true);
          Service.importProvisionalInvoice(body, 
            response => {   
              this.$store.dispatch("generic/setLoading", false);      
              if(response.success){
                this.load();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
        },
        reject: () => {
            this.$confirm.close();
        }
      });
    },
    
    exportExcel(){
        let body  = {
            dateFrom: Utils.formatDateForAPI(this.filters.initialInventoryDate),
            dateTo: Utils.formatDateForAPI(Utils.setLastDayOfMonth(this.filters.endingInventoryDate))
        }
        this.$store.dispatch("generic/setLoading", true);

        Service.exportTrueUpProvisionalInvoice(body, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          
          if(success){
              var fileURL = window.URL.createObjectURL(new Blob([data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              let fileName = `ProvisionalInvoice.xlsx`
              fileLink.setAttribute('download', fileName);
              document.body.appendChild(fileLink);
          
              fileLink.click();
          } else{
              this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
      })
    },
    closeImportFromFileDialog(value){
      this.showImportFromExcelDialog = !value;
    }
  }
}

</script>

<template>
  <main>
      <ImportWeeklyFromFile :visible="showImportFromExcelDialog" @close-import-dialog="closeImportFromFileDialog(true)"/>
      <div class="m-5">
        <div class="grid">
          <Dialog v-model:visible="showProvisionalInvoiceDialog" modal>
            <Card>
              <template #content>
                <div class="grid formgrid">
                  <div class="col-9 lg:col-3 field">
                    <label for="initialInventoryDate">{{ $t('provisionalInvoice.initialInventoryDate') }}</label>
                    <Calendar 
                    class="w-full" 
                    v-model="addProvisionalInvoice.initialInventoryDate" 
                    dateFormat="dd/mm/yy" 
                    placeholder="dd/mm/yyyy"/> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="endingInventoryDate">{{ $t('provisionalInvoice.endingInventoryDate') }}</label>
                    <Calendar 
                    class="w-full" 
                    v-model="addProvisionalInvoice.endingInventoryDate" 
                    dateFormat="dd/mm/yy" 
                    placeholder="dd/mm/yyyy"/> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="weeklyDescription">{{ $t('provisionalInvoice.weeklyDescription') }}</label>
                    <InputText id="weeklyDescription" class="w-full" v-model="addProvisionalInvoice.weeklyDescription" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="idPlanningTrueUpFamilyPoolConfiguration">{{ $t('provisionalInvoice.planningTrueUpFamilyPoolConfiguration') }}</label>
                    <InputNumber id="idPlanningTrueUpFamilyPoolConfiguration" class="w-full" v-model="addProvisionalInvoice.idPlanningTrueUpFamilyPoolConfiguration" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="familyGroup">{{ $t('provisionalInvoice.familyGroup') }}</label>
                    <InputText id="familyGroup" class="w-full" v-model="addProvisionalInvoice.familyGroup" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="familyPool">{{ $t('provisionalInvoice.familyPool') }}</label>
                    <InputText id="familyPool" class="w-full" v-model="addProvisionalInvoice.familyPool" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="cubicMeters">{{ $t('provisionalInvoice.cubicMeters') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="3" v-model="addProvisionalInvoice.cubicMeters" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="density">{{ $t('provisionalInvoice.density') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="4" v-model="addProvisionalInvoice.density" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="conversionFactor">{{ $t('provisionalInvoice.conversionFactor') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="3" v-model="addProvisionalInvoice.conversionFactor" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="barrels">{{ $t('provisionalInvoice.barrels') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="3" v-model="addProvisionalInvoice.barrels" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="metricTonnes">{{ $t('provisionalInvoice.metricTonnes') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="3" v-model="addProvisionalInvoice.metricTonnes" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="settlementBase">{{ $t('provisionalInvoice.settlementBase') }}</label>
                    <InputText class="w-full" v-model="addProvisionalInvoice.settlementBase" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="settlementDate">{{ $t('provisionalInvoice.settlementDate') }}</label>
                    <Calendar 
                    class="w-full" 
                    v-model="addProvisionalInvoice.settlementDate" 
                    dateFormat="dd/mm/yy" 
                    placeholder="dd/mm/yyyy"/> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="settle">{{ $t('provisionalInvoice.settle') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="3" v-model="addProvisionalInvoice.settle" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="premiumOrDiscount">{{ $t('provisionalInvoice.premiumOrDiscount') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="3" v-model="addProvisionalInvoice.premiumOrDiscount" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="price">{{ $t('provisionalInvoice.price') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="3" v-model="addProvisionalInvoice.price" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="escalatedPrice">{{ $t('provisionalInvoice.escalatedPrice') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="3" v-model="addProvisionalInvoice.escalatedPrice" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="invoiceAmount">{{ $t('provisionalInvoice.invoiceAmount') }}</label>
                    <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="2" v-model="addProvisionalInvoice.invoiceAmount" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="trafiguraTrade">{{ $t('provisionalInvoice.trafiguraTrade') }}</label>
                    <InputText class="w-full" v-model="addProvisionalInvoice.trafiguraTrade" /> 
                  </div>

                  <div class="col-9 lg:col-3 field">
                    <label for="isValid">{{ $t('provisionalInvoice.isValid') }}</label>
                    <GenericBooleanDropdown class="w-full" v-model="addProvisionalInvoice.isValid" /> 
                  </div>

                </div>
              </template>

              <template #footer>
                <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="m-2 p-button-sm" @click="saveProvisionalInvoice" :disabled="!uiPermissions('tankCalculatorPIButton').isEnabled" />
              </template>
            </Card>
          </Dialog>
          
          <Dialog v-model:visible="showImportDialog" modal>
            <div class="field">
              <label for="dateFromForImport">{{ $t('provisionalInvoice.dateFromForImport') }}</label>
              <Calendar 
              class="w-full" 
              v-model="this.dateFromForImport" 
              dateFormat="dd/mm/yy" 
              placeholder="dd/mm/yyyy"/> 
          </div>

          <template #footer>
              <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="showImportDialog = false"/>
              <ResponsiveButton :label="$t('btn.import')" icon="pi pi-plus" class="p-button-text" @click="importProvInvoice()" v-if="!uiPermissions('provisionalInvoiceImportButton').isHidden" />
          </template>
          </Dialog>


            <div class="col-2">
                <label for="dateFrom" :class="{'p-error':v$.filters.initialInventoryDate.$invalid && submitted}">{{$t('provisionalInvoice.initialInventoryDate')}}</label>
                    <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.filters.initialInventoryDate"
                    name="initialInventoryDate" dateFormat="dd/mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />

                <div v-if="(v$.filters.initialInventoryDate.$invalid && submitted) || v$.filters.initialInventoryDate.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.initialInventoryDate.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="col-2">
                <label for="dateFrom" :class="{'p-error':v$.filters.endingInventoryDate.$invalid && submitted}">{{$t('provisionalInvoice.endingInventoryDate')}}</label>
                    <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.filters.endingInventoryDate"
                    name="endingInventoryDate" dateFormat="dd/mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />

                <div v-if="(v$.filters.initialInventoryDate.$invalid && submitted) || v$.filters.initialInventoryDate.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.initialInventoryDate.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>

            <div class="col-12 lg:col-4 m-2">
                <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="p-button-sm mx-1" @click="load()"/>
                <!--<ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="mx-1 p-button-success" @click="openAddDialog()"/> -->
                <ResponsiveButton :label="$t('btn.import')" icon="pi pi-plus" class="mx-1 p-button-sm p-button-success" @click="showImportDialog = true" v-if="!uiPermissions('provisionalInvoiceImportButton').isHidden"/>
                <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file" class="mx-1 p-button-sm mt-3" @click="exportExcel()" />
                <ResponsiveButton :label="$t('btn.importFromFile')" icon="pi pi-file-excel" v-if="uiPermissions('provisionaInvoiceImportFromFileButton').isEnabled"
                class="mx-1 p-button-sm p-button-warning" style="color: white;" @click="showImportFromExcelDialog = true"/>
            </div>

            <div class="col-12" style="height: 80vh;">
                <GenericDataTable :configuration="configuration" :category="'planning'" :name="'true-up-provisional-invoice'" ref="provisionalInvoice" :onDialogEditSave="onProvisionalInvoiceEdit" />
            </div>
      </div>
    </div>
  </main>
</template>